import { useGetMaxLessonsPerDayQuery } from 'shared/api';
import { getColumns } from './columns';

export const useMaxLessonsPerDayTable = () => {
  const { data: maxLessonsPerDay = [], refetch } = useGetMaxLessonsPerDayQuery();
  const refreshTable = () => refetch();

  const columns = getColumns({
    refreshTable,
  });

  return {
    state: {
      dataSource: maxLessonsPerDay,
      columns,
    },
    methods: { refreshTable },
  };
};
